/* * @Author: 曹俊杰 * @Date: 2024-09-28 10:06:40 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-05-01 15:25:18 */签署状态样式

<template>
  <div class="qianshuIcon">
    <div class="qianshuIcon_r" :style="`--color:${item.color};--bg:${item.color + '0D'}`">
      {{ item.label }}
    </div>
  </div>
</template>

<script>
import selectData from "@/mixins/selectData.js";
export default {
  mixins: [selectData],
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    item() {
      return this.contractStateList.find((res) => res.value == this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.qianshuIcon {
  display: flex;
  align-items: center;

  &_r {
    color: var(--color);
    background-color: var(--bg);

    padding: 0 10px;
    height: 22px;
    line-height: 22px;
    border-radius: 20px;
    opacity: 1;

    font-family: "Noto Sans SC";
    font-size: 12px;
    font-weight: normal;
    font-variation-settings: "opsz" auto;
  }
}
</style>
